import {useUniversalFetch, useUniversalPost} from '#imports';
import {extractLink} from '~/helpers/api/ExtractLinkHelper';
import type {AdminEventRequest, AdminEventsResource} from '~/types/api-raw-types';
import {AdminEvents} from '~/types/domain/AdminEvents';
import type {Profile} from '~/types/domain/Profile';
import type {ProfileAdminRepository} from '~/types/domain/repository/ProfileAdminRepository';

function addAdminEvent(adminEvent: AdminEventRequest, profile: Profile): Promise<void> {
    const url = extractLink(profile.links, 'postAdminEvent');
    return useUniversalPost(url, {body: {...adminEvent}});
}

async function fetchAdminEvents(profile: Profile): Promise<AdminEvents> {
    try {
        const url = extractLink(profile.links, 'adminEvents');
        const resource = await useUniversalFetch<AdminEventsResource>(url);
        return new AdminEvents(resource);
    } catch (e) {
        return AdminEvents.defaultAdminEvents();
    }
}

export const profileAdminRepository: ProfileAdminRepository = {
    addAdminEvent,
    fetchAdminEvents,
};
